module.exports = __webpack_public_path__ + "static/media/loading.3f05f44d.svg";